import { __decorate, __metadata } from 'tslib';
import SchematicUIService from '../../controllers/base/schematic-ui-service.js';
import { Service } from '../../decorators/class/service.js';
import { $logger } from '../../controllers/logger/logger.js';
import { StateManager } from '../store/state-manager.js';
import { BuiltinUiState } from '../store/builtin-state.js';
import { ServiceNames } from '../../constants/service-name.js';

const reservedStatusbarItems = [
    { name: 'divider', content: null },
    { name: 'pusher', content: null },
];
const reserved = reservedStatusbarItems.map(item => item.name);
/**
 * 用于管理状态栏的服务
 *
 * @public
 */
let StatusbarService = class StatusbarService extends SchematicUIService {
    constructor(store) {
        super();
        this.store = store;
        this.schema = {
            left: [],
            right: [],
        };
        this.store.register(BuiltinUiState.Statusbar, { left: [], right: [] });
        reservedStatusbarItems.forEach((config) => {
            this.configs.set(config.name, config);
        });
    }
    /**
     * 向状态栏管理器注册状态栏组件
     *
     * @param config - 组件配置
     * @param updateImmediately - 是否立刻更新
     */
    register(config, updateImmediately = true) {
        if (reserved.includes(config.name)) {
            $logger.warn(`The statusbar config "${config.name}" is reserved.`);
            return;
        }
        super.register(config, updateImmediately);
    }
    $forceUpdate() {
        this.forceUpdateWithStore(this.store, BuiltinUiState.Statusbar);
    }
    onUpdate() {
        super.onUpdate();
        const config = {
            left: this.schema.left.reduce(this.readSchema.bind(this, 'left'), []),
            right: this.schema.right.reduce(this.readSchema.bind(this, 'right'), []),
        };
        Object.entries(this.schema).forEach(([key, schema]) => {
            schema.reduce(this.readSchema.bind(this, key), []);
        });
        this.store.get(BuiltinUiState.Statusbar).next(config);
    }
    mergeSchemaWithoutUpdate(schema) {
        this.schema = {
            left: this.schema.left.concat(schema.left),
            right: this.schema.right.concat(schema.right),
        };
    }
    readSchema(key, root, item) {
        const config = Object.assign({}, this.get(item));
        this.setPathToActionInfoInConfig(config, [key]);
        root.push(config);
        return root;
    }
    get(name) {
        return super.get(name, {
            content: null,
            name: 'none',
        });
    }
};
StatusbarService = __decorate([
    Service({ overridable: true, scope: 'ui:service', name: ServiceNames.STATUSBAR }),
    __metadata("design:paramtypes", [StateManager])
], StatusbarService);

export { StatusbarService };
//# sourceMappingURL=statusbar-service.js.map
